
import { mapState } from "vuex";

export default {
  name: "RenewIndex",
  components: {},
  middleware: ["notAuthenticated"],

  data() {
    return {
      fullYear: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapState("application", ["unverifiedUsername", "taggedVersion"]),
  },
  beforeMount() {
    if (!this.unverifiedUsername) {
      this.$router.push(`/login`);
    }
  },
};
